import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function OneLiners() {
  const oneLiners = ["This isn't voice AI. It's AI with a voice.", 'If ChatGPT is your writer — Critical Voice is your closer.', 'Why settle for chat when your customers want a conversation?', "OpenAI showed the world what's possible — we made it usable."];
  return <section className="w-full py-20 px-6 md:px-10 lg:px-20 bg-[#111]" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <div className="text-center mb-10" data-id="element-178">
          <h2 className="text-lg font-semibold uppercase tracking-wider text-[#00E0FF] mb-3" data-id="element-179">
            One-Liners To Drop In A Pitch
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-180">
          {oneLiners.map((line, index) => <div key={index} className="p-6 rounded-xl bg-[#222] border border-gray-800 flex items-start hover:border-[#00E0FF]/30 hover:shadow-[0_0_15px_rgba(0,224,255,0.1)] transition-all" data-id="element-181">
              <QuoteIcon className="w-8 h-8 text-[#00E0FF] mr-4 flex-shrink-0" data-id="element-182" />
              <p className="text-xl font-medium" data-id="element-183">{line}</p>
            </div>)}
        </div>
      </div>
    </section>;
}